import api from '~/services/pluginbot-api';

/**
 * Dispara entrega indoor (Pudu / conversation app) via sessão pluginspace.
 * Headers padrão do axios (Authorization, app, group) vêm de `pluginbot-api` + sagas.
 *
 * @param {object} body — no mínimo `robot_code`; demais campos repassados à integração.
 * @param {object} [options]
 * @param {string} [options.robotType] — query `robot_type` (ex.: slug do tipo de robô).
 */
export function postRobotDelivery(body, options = {}) {
    const { robotType } = options;
    const config = {};
    if (robotType) {
        config.params = { robot_type: robotType };
    }
    return api.post('robots/delivery', body, config);
}
